import images from "./images";

const services = [
    {
        image: `${images.services_img_1}`,
        title: "Frontend Development",
        paragraph: "Brand New Front-End Dev crafting visually appealing user interfaces with HTML, CSS, JavaScript, React, Redux, TypeScript, Bootstrap, and jQuery."
    },
    {
        image: `${images.services_img_2}`,
        title: "Backend Development",
        paragraph: "Backend Developer as a beginner in Node.js, Express.js, MongoDB, and SQL Server and Knowledge in Java, C++, and PHP."
    },
    {
        image: `${images.services_img_3}`,
        title: "Software Testing",
        paragraph: "Quality Assurance with a focus on identifying and resolving software defects to ensure optimal product performance and user experience."
    },
    {
        image: `${images.services_img_4}`,
        title: "Installation",
        paragraph: "Delivered exceptional customer service throughout the POS installation process."
    },
    {
        image: `${images.services_img_5}`,
        title: "Database Management",
        paragraph: "Database Architect & Administrator: Designed, implemented, and optimized relational databases to ensure data integrity, security, and efficient retrieval.."
    },
    {
        image: `${images.services_img_6}`,
        title: "Customer Support",
        paragraph: "Dedicated to providing exceptional support and resolving customer issues efficiently.."
    },
];

const works = [
    {
        image: `${images.work_img_1}`
    },
    {
        image: `${images.work_img_2}`
    },
    {
        image: `${images.work_img_3}`
    },
    {
        image: `${images.work_img_4}`
    },
    {
        image: `${images.work_img_5}`
    },
    {
        image: `${images.work_img_6}`
    },
];

const logos = [
    {
        image: `${images.logo_img_1}`
    },
    {
        image: `${images.logo_img_2}`
    },
    {
        image: `${images.logo_img_3}`
    },
    {
        image: `${images.logo_img_4}`
    },
    {
        image: `${images.test_img_5}`
    },
    {
        image: `${images.test_img_6}`
    },
];

export {services, works,logos};
